<template>
  <div class="contents meijisyo detail">
    <div class="container">
      <loading v-if="!isInit" :message="'就業条件明示書の準備中...'"></loading>
      <section class="meijisyo-detail" v-if="isInit && meijisyo">
        <p>次の条件で労働者派遣を行います。</p>
        <div class="group">
          <div class="group-head vertical-text">派遣先</div>
          <div class="group-content">
            <article class="row">
              <div class="head">就業場所</div>
              <div class="detail flex">
                <div class="syuugyou-basyo-name">
                  <p class="sub-head">（名称）</p>
                  <p class="data" v-if="!isEditing">{{ meijisyo.syuugyou_basyo_name }}</p>
                  <input-text v-else type="text" v-model=meijisyo.syuugyou_basyo_name />
                </div>
                <div class="busyo-name">
                  <p class="sub-head">（部署）</p>
                  <p class="data" v-if="!isEditing">{{ meijisyo.syuugyou_basyo_busyo_name }}</p>
                  <input-text v-else type="text" v-model=meijisyo.syuugyou_basyo_busyo_name />
                </div>
                <div class="busyo-name">
                  <p class="sub-head">（住所）</p>
                  <p class="data">{{ meijisyo.koyou_keiyaku?.syuugyou_basyo_address }}</p>
                </div>
                <div class="busyo-name">
                  <p class="sub-head">（電話）</p>
                  <p class="data">{{ meijisyo.koyou_keiyaku?.syuugyou_basyo_tel }}</p>
                </div>
              </div>
            </article>

            <article class="row">
              <div class="head">組織単位</div>
              <div class="detail">
                <p class="data" v-if="!isEditing">{{ meijisyo.soshiki_tanni }}</p>
                <input-text v-else type="text" v-model=meijisyo.soshiki_tanni />
              </div>
            </article>

            <article class="row">
              <div class="head">業務内容</div>
              <div class="detail">
                <p v-if="meijisyo.koyou_keiyaku && meijisyo.koyou_keiyaku.work_detail1">{{
                  meijisyo.koyou_keiyaku.work_detail1
                }}</p>
                <p v-if="meijisyo.koyou_keiyaku && meijisyo.koyou_keiyaku.work_detail2">{{
                  meijisyo.koyou_keiyaku.work_detail2
                }}</p>
              </div>
            </article>

            <article class="row">
              <div class="head">指揮命令者</div>
              <div class="detail flex">
                <div class="busyo-name">
                  <p class="sub-head">（部署）</p>
                  <p class="data" v-if="!isEditing">{{ meijisyo.shikimeirei_busyo }}</p>
                  <input-text v-else type="text" v-model=meijisyo.shikimeirei_busyo />
                </div>
                <div class="busyo-name">
                  <p class="sub-head">（電話）</p>
                  <p class="data" v-if="!isEditing">{{ meijisyo.shikimeirei_tel }}</p>
                  <input-text v-else type="text" v-model=meijisyo.shikimeirei_tel />
                </div>
                <div class="busyo-name">
                  <p class="sub-head">（役職）</p>
                  <p class="data" v-if="!isEditing">{{ meijisyo.shikimeirei_yakusyoku }}</p>
                  <input-text v-else type="text" v-model=meijisyo.shikimeirei_yakusyoku />
                </div>
                <div class="busyo-name">
                  <p class="sub-head">（氏名）</p>
                  <p class="data" v-if="!isEditing">{{ meijisyo.shikimeirei_shimei }}</p>
                  <input-text v-else type="text" v-model=meijisyo.shikimeirei_shimei />
                </div>
              </div>
            </article>
          </div>
        </div>

        <article class="row">
          <div class="head">責任の程度</div>
          <div class="detail">
            <p>役職を有さない（部下無し）</p>
          </div>
        </article>

        <article class="row">
          <div class="head">派遣期間</div>
          <div class="detail">
            <p>
              <span v-if="meijisyo.koyou_keiyaku && meijisyo.koyou_keiyaku.keiyaku_date">
                {{ dateFormatJp(meijisyo.koyou_keiyaku.keiyaku_date) }}から</span>
              <span v-if="meijisyo.koyou_keiyaku && meijisyo.koyou_keiyaku.koyou_end_date">
                {{ dateFormatJp(meijisyo.koyou_keiyaku.koyou_end_date) }}
              </span>
            </p>
            <div class="flex sub-info">
              <p class="sub-head">(派遣先の事業所における期間制限に抵触する最初の日：</p>
              <p class="data" v-if="!isEditing">{{ meijisyo.hakensaki_saisyono }})</p>
              <input-text v-else type="text" v-model=meijisyo.hakensaki_saisyono />
            </div>
            <div class="flex sub-info">
              <p class="sub-head">(組織単位における期間制限に抵触する最初の日：</p>
              <p class="data" v-if="!isEditing">{{ meijisyo.soshikitani_saisyonohi }})</p>
              <input-text v-else type="text" v-model=meijisyo.soshikitani_saisyonohi />
            </div>
          </div>
        </article>

        <article class="row">
          <div class="head">就業日</div>
          <div class="detail">
            <p></p>
          </div>
        </article>

        <article class="row">
          <div class="head">就業時間</div>
          <div class="detail">
            <template v-if="meijisyo.koyou_keiyaku?.koyou_keiyaku_times && options">
              <template v-for="time in meijisyo.koyou_keiyaku.koyou_keiyaku_times">
                <p class="time" >
                  <span class="start">始業 {{ timeToHHmmJpPeriod(time.start_time) }}</span>
                  <span>から</span>
                  <span class="start">終業 {{ timeToHHmmJpPeriod(time.end_time) }}</span>
                  <span class="youbi">
                    [{{ getYoubiLabel(time).join('・') }}]
                  </span>
                  <span class="jitsudou">実働：{{ timeToHHmmJp(time.tsuujou_times) }}</span>
                  <span class="kyuukei">（休憩：{{ timeToHHmmJp(time.kyuukei_times) }}）</span>
                </p>
                <p v-if="time.weeks">※第{{ time.weeks }}週</p>
              </template>
              <!-- <p class="time" v-for="time in meijisyo.koyou_keiyaku.koyou_keiyaku_times">
                <span class="start">始業 {{ timeToHHmmJpPeriod(time.start_time) }}</span>
                <span>から</span>
                <span class="start">終業 {{ timeToHHmmJpPeriod(time.end_time) }}</span>
                <span class="youbi">
                  [{{ getYoubiLabel(time).join('・') }}]
                </span>
                <span class="jitsudou">実働：{{ timeToHHmmJp(time.tsuujou_times) }}</span>
                <span class="kyuukei">（休憩：{{ timeToHHmmJp(time.kyuukei_times) }}）</span>
              </p> -->
            </template>
          </div>
        </article>

        <article class="row">
          <div class="head">休憩時間</div>
          <div class="detail">
            <p>就業時間欄に記載のとおり</p>
          </div>
        </article>

        <article class="row">
          <div class="head">時間外（休日）労働</div>
          <div class="detail">
            <p>1日4時間、1ヶ月45時間、1年360時間以内とする。休日労働は月2日以内とする。</p>
          </div>
        </article>

        <article class="row">
          <div class="head">派遣先責任者</div>
          <div class="detail flex">
            <div class="busyo-name">
              <p class="sub-head">（部署）</p>
              <p class="data" v-if="!isEditing">{{ meijisyo.hakensaki_sekininsya_busyo }}</p>

              <input-text v-else type="text" v-model=meijisyo.hakensaki_sekininsya_busyo />
            </div>

            <div class="busyo-name">
              <p class="sub-head">（電話）</p>
              <p class="data" v-if="!isEditing">{{ meijisyo.hakensaki_sekininsya_tel }}</p>
              <input-text v-else type="text" v-model=meijisyo.hakensaki_sekininsya_tel />

            </div>

            <div class="busyo-name">
              <p class="sub-head">（役職）</p>
              <p class="data" v-if="!isEditing">{{ meijisyo.hakensaki_sekininsya_yakusyoku }}</p>
              <input-text v-else type="text" v-model=meijisyo.hakensaki_sekininsya_yakusyoku />
            </div>

            <div class="busyo-name">
              <p class="sub-head">（氏名）</p>
              <p class="data" v-if="!isEditing">{{ meijisyo.hakensaki_sekininsya_shimei }}</p>
              <input-text v-else type="text" v-model=meijisyo.hakensaki_sekininsya_shimei />
            </div>
          </div>
        </article>

        <article class="row">
          <div class="head">派遣元責任者</div>
          <div class="detail flex">
            <div class="busyo-name">
              <p class="sub-head">（部署）</p>
              <p class="data" v-if="!isEditing">{{ meijisyo.hakenmoto_sekininsya_busyo }}</p>
              <input-text v-else type="text" v-model=meijisyo.hakenmoto_sekininsya_busyo />

            </div>
            <div class="busyo-name">
              <p class="sub-head">（電話）</p>
              <p class="data" v-if="!isEditing">{{ meijisyo.hakenmoto_sekininsya_tel }}</p>
              <input-text v-else type="text" v-model=meijisyo.hakenmoto_sekininsya_tel />
            </div>

            <div class="busyo-name">
              <p class="sub-head">（役職）</p>
              <p class="data" v-if="!isEditing">{{ meijisyo.hakenmoto_sekininsya_yakusyoku }}</p>
              <input-text v-else type="text" v-model=meijisyo.hakenmoto_sekininsya_yakusyoku />
            </div>

            <div class="busyo-name">
              <p class="sub-head">（氏名）</p>
              <p class="data" v-if="!isEditing">{{ meijisyo.hakenmoto_sekininsya_shimei }}</p>
              <input-text v-else type="text" v-model=meijisyo.hakenmoto_sekininsya_shimei />
            </div>
          </div>
        </article>

        <div class="group">
          <div class="group-head vertical-text">苦情処理</div>
          <div class="group-content">
            <article class="row">
              <div class="head">派遣先申出先</div>
              <div class="detail flex">
                <div class="busyo-name">
                  <p class="sub-head">（部署）</p>
                  <p class="data" v-if="!isEditing">{{ meijisyo.hakensaki_moushidesaki_busyo }}</p>
                  <input-text v-else type="text" v-model=meijisyo.hakensaki_moushidesaki_busyo />

                </div>
                <div class="busyo-name">
                  <p class="sub-head">（電話）</p>
                  <p class="data" v-if="!isEditing">{{ meijisyo.hakensaki_moushidesaki_tel }}</p>
                  <input-text v-else type="text" v-model=meijisyo.hakensaki_moushidesaki_tel />
                </div>

                <div class="busyo-name">
                  <p class="sub-head">（役職）</p>
                  <p class="data" v-if="!isEditing">{{ meijisyo.hakensaki_moushidesaki_yakusyoku }}</p>
                  <input-text v-else type="text" v-model=meijisyo.hakensaki_moushidesaki_yakusyoku />
                </div>

                <div class="busyo-name">
                  <p class="sub-head">（氏名）</p>
                  <p class="data" v-if="!isEditing">{{ meijisyo.hakensaki_moushidesaki_shimei }}</p>
                  <input-text v-else type="text" v-model=meijisyo.hakensaki_moushidesaki_shimei />
                </div>
              </div>
            </article>

            <article class="row">
              <div class="head">派遣元申出先</div>
              <div class="detail flex">
                <div class="busyo-name">
                  <p class="sub-head">（部署）</p>
                  <p class="data" v-if="!isEditing">{{ meijisyo.hakenmoto_moushidesaki_busyo }}</p>
                  <input-text v-else type="text" v-model=meijisyo.hakenmoto_moushidesaki_busyo />
                </div>

                <div class="busyo-name">
                  <p class="sub-head">（電話）</p>
                  <p class="data" v-if="!isEditing">{{ meijisyo.hakenmoto_moushidesaki_tel }}</p>
                  <input-text v-else type="text" v-model=meijisyo.hakenmoto_moushidesaki_tel />
                </div>

                <div class="busyo-name">
                  <p class="sub-head">（役職）</p>
                  <p class="data" v-if="!isEditing">{{ meijisyo.hakenmoto_moushidesaki_yakusyoku }}</p>
                  <input-text v-else type="text" v-model=meijisyo.hakenmoto_moushidesaki_yakusyoku />
                </div>

                <div class="busyo-name">
                  <p class="sub-head">（氏名）</p>
                  <p class="data" v-if="!isEditing">{{ meijisyo.hakenmoto_moushidesaki_shimei }}</p>
                  <input-text v-else type="text" v-model=meijisyo.hakenmoto_moushidesaki_shimei />
                </div>
              </div>
            </article>

            <article class="row">
              <div class="head">苦情の処理方法<br>及び連携体制</div>
              <div class="detail">
                <p>派遣先・派遣元における上記の者が派遣労働者から苦情等の申出を受けた場合は、直ちに所属の責任者に連絡することとし、当該責任者が中心となって誠意をもって遅延なく対応する。派遣先及び派遣元において解決が容易であり、即時に処理した苦情の他は、相互に遅延なく通知するとともに、その結果について派遣労働者に通知することとする。</p>
              </div>
            </article>
          </div>
        </div>

        <article class="row">
          <div class="head">安全及び衛生</div>
          <div class="detail">
            <p>派遣先および派遣元は、派遣者が～</p>
          </div>
        </article>

        <article class="row">
          <div class="head">福祉増進のための<br>便宜供与</div>
          <div class="detail">
            <p>派遣先は派遣労働者に対し、派遣先が雇用する労働者が利用する食堂、休憩室、その他福利厚生施設等について、利用することができるように便宜供与する。</p>
          </div>
        </article>

        <article class="row">
          <div class="head">派遣労働者の雇用の安定<br>を図るための措置</div>
          <div class="detail">
            <p class="detail-head">（1）労働者派遣契約の解除の事前の申入れ</p>
            <p class="indent">派遣先は、専ら派遣先に起因する事由により、労働者派遣契約の契約期間が満了する前の解除を行おうとする場合には、派遣元の合意を得ることはもとより、あらかじめ相当の猶予期間をもって派遣元に解除の申入れを行うこととする。</p>
            <p class="detail-head">（2）派遣先における就業機会の確保</p>
            <p class="indent">派遣先及び派遣元は、労働者派遣契約の契約期間が満了する前に派遣労働者の責に帰すべき事由によらない労働者派遣契約の解除を行った場合には、派遣先の関連施設での就業をあっせんする等により、当該労働者派遣契約に係る派遣労働者の新たな就業機会の確保を図ることとする。</p>
            <p class="detail-head">（3）損害賠償等に係る適切な措置</p>
            <p class="indent">派遣先は、派遣先の責に帰すべき事由により労働者派遣契約の契約期間が満了する前に労働者派遣契約の解除を行おうとする場合には、派遣労働者の新たな就業機会の確保を図ることとし、これができないときには、少なくとも当該労働者派遣契約の解除に伴い派遣元が労働者派遣契約に係る派遣労働者を休業させること等を余儀なくされたことにより生じた休業手当に相当する額以上の額について、また派遣元がやむを得ない事由により当該派遣労働者を解雇する場合は、派遣先による解除の申し入れが相当の猶予期間をもって行われなかったことにより、派遣元が解雇の予告をしないときは、少なくとも30日分以上の賃金に相当する額について、当該予告をした日から解雇の日までの期間が30日に満たないときは当該解雇の日30日前から当該予告の日までの日数分以上の賃金に相当する額についての損害の賠償を行わなければならないこととする。その他派遣先は派遣元と十分に協議した上で適切な善後処理方策を講ずることとする。また、派遣先及び派遣元双方の責に帰すべき事由がある場合には、派遣先及び派遣元のそれぞれの責に帰すべき部分の割合についても十分に考慮することとする。</p>
            <p class="detail-head">（4）労働者派遣契約の解除の理由の明示</p>
            <p class="indent">派遣先は、労働者派遣契約の契約期間が満了する前に労働者派遣契約の解除を行おうとする場合であって、派遣元から請求があったときは、労働者派遣契約の解除を行った理由を派遣元に対して明らかにすることとする。</p>
          </div>
        </article>

        <article class="row">
          <div class="head">派遣先が派遣労働者を<br>雇用する場合の紛争<br>防止措置</div>
          <div class="detail">
            <p>労働者派遣の役務の提供の終了後、当該派遣労働者を派遣先が雇用する場合には、<br>あらかじめ相当の猶予期間をもって派遣元に申し出ること。</p>
          </div>
        </article>
        <div class="hakenmoto-info">
          <dl>
            <dt>事業所名</dt>
            <dd>株式会社メディカスタッフプログレス</dd>
          </dl>
          <dl>
            <dt>所在地</dt>
            <dd>新潟市中央区上大川前通１０番町１８７１番地</dd>
          </dl>
          <dl>
            <dt>使用者職氏名</dt>
            <dd>代表取締役 八尾坂 克也</dd>
          </dl>
          <dl>
            <dt>許可番号</dt>
            <dd>派15-010044</dd>
          </dl>
        </div>
      </section>
    </div>


    <div class="button-container">
      <p class="prev-page">
        <router-link
          :to="{ name: RouterConst.KOYOUKEIYAKU_DETAIL, params: { koyouKeiyakuId: koyouKeiyakuId } }">戻る</router-link>
      </p>
      <button type="button" class="btn cancel" v-if="isInit && isEditing" :disabled="isSaving" @click="endEditMode()">
        <p>保存せずに終了</p>
      </button>
      <button type="button" class="btn success" v-if="isInit && isEditing" :disabled="isSaving" @click="update()">
        <p>保存する</p>
      </button>
      <button type="button" class="btn success" v-if="isInit && !isEditing" @click="startEditMode()">
        <p>編集する</p>
      </button>
    </div><!--button-container-->
  </div>
</template>


<script lang="ts">

import { defineComponent, ref, onMounted } from 'vue';
import OptionConst from '@/const/Option';
import { useRoute } from 'vue-router';
import { RouterConst } from '@/const/Router';
import { useSyuugyouJoukenMeijisyoInit } from '@/composable/meijisyo/init';
import { dateFormatJp, timeToHHmmJp, timeToHHmmJpPeriod } from '@/filters/common';
import { DialogService } from '@/service/DialogService';
import router from '@/routers';
import { useKoyouKeiyakuInit } from '@/composable/koyoukeiyaku/init';

export default defineComponent({
  setup() {
    const isError = ref(false)
    const isInit = ref(false)
    const route = useRoute()

    const createModeRoute = { name: RouterConst.MEIJISYO_EDIT, query: { mode: 'create' } }
    const isSaving = ref(false);
    const { options, getAllKoyouKeiyakuOption, getOptionsLabel, getYoubiLabel } = useKoyouKeiyakuInit()

    const { meijisyo, findByKoyouKeiyakuId, initMeijisyo, createMeijisyo, updateMeijisyo, isEditing, koyouKeiyakuId, startEditMode, endEditMode } = useSyuugyouJoukenMeijisyoInit()
    onMounted(async () => {
      koyouKeiyakuId.value = parseInt(route.params.id as string, 10)
      if (!koyouKeiyakuId.value) {
        await DialogService.error({
          title: '明示書の表示に失敗しました',
          text: '雇用契約IDが指定されていません'
        })
        backPrevPage()
        return
      }
      await findByKoyouKeiyakuId()

      if (!meijisyo.value) {
        const result = await DialogService.question({
          html: 'この雇用契約に対する明示書はまだ作成されていません。<br>雇用契約の内容を元に作成します。',
          confirmButtonText: '作成する',
          cancelButtonText: '今はしない',
          showCancelButton: true
        })
        if (result.isConfirmed) {
          // 保存を実行（サーバー側で契約内容を反映した状態の明示書が生成される）
          await create()
        } else {
          backPrevPage()
        }
      }

      await getAllKoyouKeiyakuOption()
      isInit.value = true
    })

    const backPrevPage = () => {
      if (koyouKeiyakuId.value) {
        router.push({ name: RouterConst.KOYOUKEIYAKU_DETAIL, params: { id: koyouKeiyakuId.value } })
      } else {
        // 直アクセスやリロードなどでparamsが取れない場合
        router.push({ name: RouterConst.KOYOUKEIYAKU_MENU })
      }
    }

    const update = async () => {
      isSaving.value = true
      try {
        await updateMeijisyo()
        await findByKoyouKeiyakuId()
        await endEditMode()
      } catch (e) {
      } finally {
        isSaving.value = false
      }
    }

    const create = async () => {
      isSaving.value = true
      try {
        await initMeijisyo()
        await createMeijisyo()
        await findByKoyouKeiyakuId()
      } catch (e) {
      } finally {
        isSaving.value = false
      }
    }

    return {
      isInit,
      isError,
      OptionConst,
      koyouKeiyakuId,
      meijisyo,
      RouterConst,
      createModeRoute,
      findByKoyouKeiyakuId,
      dateFormatJp,
      isEditing,
      isSaving,
      update,
      startEditMode,
      endEditMode,
      getOptionsLabel,
      options,
      timeToHHmmJp,
      timeToHHmmJpPeriod,
      getYoubiLabel
    }
  },
  components: {
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/meijisyo.scss';
</style>